import docCookies from 'doc-cookies';
import { BASE_URL_SANCTUM, BASE_CUSTOM_PAYMENT_URL } from '../misc/consts';

export default () => {
  return {
    async getXsfrToken() {
      const response = await fetch(BASE_URL_SANCTUM);
      if (!response.ok) {
        this.somethingWentWrong = true;
        throw new Error(`Error! status: ${response.status}`);
      }
    },

    async deleteCustomPayment(id) {
      await this.getXsfrToken();
      fetch(`${BASE_CUSTOM_PAYMENT_URL}/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
        },
        method: 'DELETE',
      }).then((response) => {
        if (response.ok) {
          this.$el.parentElement.parentElement.parentElement.parentElement.remove();
        }
      });
    },
  };
};
